<!-- Label and controls header - only render if label exists or controls are needed -->
@if (_hasLabel() || showRequiredToggle() || removable()) {
  <div class="hx-form-header">
    <!-- Label projection slot -->
    <ng-content select="hx-label" />

    <!-- Required Toggle and Trash Icon Controls -->
    <div class="hx-form-controls">
      @if (showRequiredToggle()) {
        <button
          hxIconButton
          variant="ghost"
          aria-label="Toggle"
          (click)="_toggleRequired()"
          class="hx-form-required-toggle"
          type="button"
          title="Toggle Field">
          <span class="hx-toggle-switch" [class.active]="_isRequiredToggle">
            <span class="hx-toggle-dot"></span>
          </span>
        </button>
      }

      @if (removable()) {
        <button
          hxIconButton
          variant="ghost"
          aria-label="Delete"
          (click)="_removeBlock()"
          type="button"
          title="Remove field">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M2 4.5L18 4.5M7 1.5L13 1.5M13.5 18.5H6.5C5.39543 18.5 4.5 17.6046 4.5 16.5L4.0434 5.54163C4.01973 4.97351 4.47392 4.5 5.04253 4.5L14.9575 4.5C15.5261 4.5 15.9803 4.97351 15.9566 5.54163L15.5 16.5C15.5 17.6046 14.6046 18.5 13.5 18.5Z"
              stroke="#E85E63"
              stroke-width="1.6"
              stroke-linecap="round" />
          </svg>
        </button>
      }
    </div>
  </div>
}

<!-- Input container with prefix/suffix support (Angular Material pattern) -->
<div class="hx-form-input-container">
  <!-- Icon Prefix (separate for proper spacing) -->
  @if (_hasIconPrefix) {
    <div class="hx-form-icon-prefix">
      <ng-content select="[hxIconPrefix]" />
    </div>
  }

  <!-- Text Prefix (separate for proper spacing) -->
  @if (_hasTextPrefix) {
    <div class="hx-form-text-prefix">
      <ng-content select="[hxPrefix], [hxTextPrefix]" />
    </div>
  }

  <!-- Infix - Contains the actual input/textarea control -->
  <div class="hx-form-infix">
    <ng-content />
  </div>

  <!-- Text Suffix (separate for proper spacing) -->
  @if (_hasTextSuffix) {
    <div class="hx-form-text-suffix">
      <ng-content select="[hxSuffix], [hxTextSuffix]" />
    </div>
  }

  <!-- Icon Suffix (separate for proper spacing) -->
  @if (_hasIconSuffix) {
    <div class="hx-form-icon-suffix">
      <ng-content select="[hxIconSuffix]" />
    </div>
  }
</div>

<!-- Subscript wrapper (errors OR hints, never both) - only render if content exists -->
@if (_hasSubscriptContent()) {
  <div class="hx-form-subscript-wrapper">
    @if (_shouldShowError()) {
      <!-- Error messages with aria-live announcement -->
      <div aria-live="polite" class="hx-form-error-wrapper">
        <ng-content select="[hx-error]" />
      </div>
    } @else {
      <!-- Helper text (hidden when errors shown) -->
      <ng-content select="[hx-hint]" />
    }
  </div>
}
